<template>
<!-- DATATABLE HEADER-->
<v-card tile flat class="hidden-sm-and-down">
    <v-row no-gutters>
        <div v-for="(item, index) in items" :style="{width: item.width}" :key="index" class="pa-2 detail">
            <div :class="{'pointer': item.sortable, 'header-title': true}" @click="changeOrder(item, index)" :style="{'justify-content': alignValue(item.align)}">
                <span class="text-capitalize">{{ item.text }}</span>
                <v-icon v-if="item.sort_dir==='asc'" small>arrow_upwards</v-icon>
                <v-icon v-if="item.sort_dir==='desc'" small>arrow_downwards</v-icon>
            </div>
        </div>
    </v-row>
</v-card>
<!-- ./ DATATABLE HEADER-->
</template>

<script>
export default {
    name: "IMTableHeader",
    props: {
        items: Array,
    },

    computed: {


    },
    methods: {
        changeOrder(value, item_index) {
            if(value.sortable === true) {
                this.items.forEach(function (element, index) {
                    if(item_index !== index) {
                        element.sort_dir = null;
                    }
                });


                if(this.items[item_index].sort_dir === null) {
                    this.items[item_index].sort_dir = "asc";
                    this.$emit("clickSort", value);
                } else if(this.items[item_index].sort_dir === "asc") {

                    this.items[item_index].sort_dir = "desc";
                    this.$emit("clickSort", value);

                } else if(this.items[item_index].sort_dir === "desc") {

                    this.items[item_index].sort_dir = "asc";
                    this.$emit("clickSort", value);
                }
            }

        },
        alignValue(value) {
            switch (value) {
            case 'left':
                return 'flex-start';
            case 'center':
                return 'center';
            case 'right':
                return 'flex-end';
            default:
                return 'left';
            }
        },
    }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}

.header-title {
    display: flex;
    width: 100%;
}
</style>
